module.exports = __webpack_public_path__ + "media/images/Banner_SportApp_780x520-493911f0f2d6f26d99eac2d90584f5d9.jpg";